import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Box,
    Button,
    HStack,
    Flex,
    Icon,
} from '@chakra-ui/react';
import { TbArrowRight } from 'react-icons/tb';

export interface RevertToOriginalModalProps {
    isOpen: boolean;
    onClose: () => void;
    fieldLabel: string;
    originalValue: string;
    currentValue: string;
    onRevert: () => void;
}

const RevertToOriginalModal = ({
    isOpen,
    onClose,
    fieldLabel,
    originalValue,
    currentValue,
    onRevert,
}: RevertToOriginalModalProps) => {
    const handleRevert = () => {
        onRevert();
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="lg" fontWeight="semibold" color="gray.800">
                    {fieldLabel}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Text fontSize="md" color="gray.600" mb={5}>
                        This value was changed from what was originally extracted from the invoice
                    </Text>

                    <Box bg="gray.50" borderRadius="xl" p={6}>
                        <Flex align="center" justify="center" gap={4}>
                            <Box
                                flex="1"
                                maxW="240px"
                                bg="white"
                                borderRadius="lg"
                                p={5}
                                border="1px solid"
                                borderColor="gray.200"
                                textAlign="center"
                            >
                                <Text
                                    fontSize="xs"
                                    fontWeight="bold"
                                    color="orange.500"
                                    textTransform="uppercase"
                                    letterSpacing="wider"
                                    mb={3}
                                >
                                    Original
                                </Text>
                                <Text fontSize="xl" fontWeight="bold" color="gray.900" wordBreak="break-word">
                                    {originalValue || '—'}
                                </Text>
                            </Box>

                            <Icon
                                as={TbArrowRight as React.ElementType}
                                boxSize={6}
                                color="#0071E3"
                                flexShrink={0}
                            />

                            <Box
                                flex="1"
                                maxW="240px"
                                bg="white"
                                borderRadius="lg"
                                p={5}
                                border="1px solid"
                                borderColor="gray.200"
                                textAlign="center"
                            >
                                <Text
                                    fontSize="xs"
                                    fontWeight="bold"
                                    color="orange.500"
                                    textTransform="uppercase"
                                    letterSpacing="wider"
                                    mb={3}
                                >
                                    Current
                                </Text>
                                <Text fontSize="xl" fontWeight="bold" color="gray.900" wordBreak="break-word">
                                    {currentValue || '—'}
                                </Text>
                            </Box>
                        </Flex>
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button size="action" variant="ghost" onClick={onClose}>
                            Keep current
                        </Button>
                        <Button size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }} onClick={handleRevert}>
                            Revert to original
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default RevertToOriginalModal;
